import { BaseSocketListener } from '~/web-frontend-core/api/connector/socketListener/BaseSocketListener';
import { AxiosSocket } from '~/web-frontend-core/api/connector/socketListener/socket/Axios';
const XHR_URL = '/wss/xhr/';
export class XHRSocketListener extends BaseSocketListener {
}
XHRSocketListener.createSocket = () => new AxiosSocket(XHR_URL);
XHRSocketListener.toString = () => 'XHRSocketListener';



// WEBPACK FOOTER //
// ./src/web-frontend-core/api/connector/socketListener/XHR.js